module.exports = "/dist/81826529772e52f0f14a4c73c2f2c7f1.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-700.woff
// module id = 132
// module chunks = 0